import React from "react";
import "./PackagesSection.css";
import { getPackagesByCountry } from "../../../API/home";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { HiArrowLongLeft, HiArrowLongRight } from "react-icons/hi2";
import "swiper/css";
import "swiper/css/navigation";
import { useSearchParams } from "react-router-dom";

const PackagesSection = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialCountry = searchParams.get("country") || "Tanzania";
  const [activeCountry, setActiveCountry] = React.useState(initialCountry);
  const [packages, setPackages] = React.useState([]);
  const navigate = useNavigate();
  const prevRef = React.useRef(null);
  const nextRef = React.useRef(null);

  const countrySlugMap = {
    Tanzania: "tanzania",
    India: "india",
    UAE: "uae",
    Kenya: "kenya",
    "South Africa": "south-africa",
    Qatar: "qatar",
    Malaysia: "malaysia",
    Singapore: "singapore",
    Uganda: "uganda",
    Zambia: "zambia",
    Zimbabwe: "zimbabwe",
    // Kazakhstan: "kazakhstan",
  };

  const countrySlug = countrySlugMap[activeCountry];

  React.useEffect(() => {
    if (!activeCountry) return;

    const countryCodeMap = {
      Tanzania: "TZ",
      India: "IN",
      UAE: "AE",
      Kenya: "KE",
      "South Africa": "ZA",
      Qatar: "QA",
      Malaysia: "MY",
      Singapore: "SG",
      Uganda: "UG",
      Zambia: "ZM",
      Zimbabwe: "ZW",
      // Kazakhstan: "KZ",
    };

    const fetchPackages = async () => {
      const code = countryCodeMap[activeCountry];

      if (!code) return;

      const data = await getPackagesByCountry(code);

      const formatted = data.map((item) => ({
        id: item.id,
        title: item.packageName,
        // days: `${item.numberOfNights}N/${item.numberOfNights + 1}D`,
        days: `${item.numberOfNights} days`,
        location: item.cityName,
        price: `USD ${item.priceStartingFrom}`,
        image: item.profileImagePath,
        shortDescription: item.shortDescription,
        rating: item.rating || 4,
        slug: item.slug,
      }));

      setPackages(formatted);
    };

    fetchPackages();
  }, [activeCountry]);

  const handleCountryChange = (country) => {
    setActiveCountry(country);
    setSearchParams({ country });
  };

  React.useEffect(() => {
    const countryFromUrl = searchParams.get("country");

    if (countryFromUrl && countryFromUrl !== activeCountry) {
      setActiveCountry(countryFromUrl);
    }
  }, [searchParams]);

  const countryTabs = [
    "Tanzania",
    "India",
    "Kenya",
    "South Africa",
    // "Kazakhstan",
    "Qatar",
    "Uganda",
    // "Rwanda",
    "UAE",
    "Zambia",
    "Malaysia",
    "Zimbabwe",
    "Singapore",
  ];

  return (
    <section className="standard-padding">
      {/* HEADER */}

      <div className="packages-header">
        <h1 className="heading mobile-head">
          Curated {activeCountry} Journeys for B2B Partners
        </h1>
      </div>

      <div className="packages-tabs-div">
        {countryTabs.map((tab) => (
          <button
            key={tab}
            className={`package-tab ${activeCountry === tab ? "active" : ""}`}
            onClick={() => handleCountryChange(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* SLIDER */}

      {packages.length > 0 ? (
        <div className="packages-slider-wrapper">
          {/* <div
            ref={prevRef}
            className="custom-arrow prev"
          >
            ❮
          </div>

          <div
            ref={nextRef}
            className="custom-arrow next"
          >
            ❯
          </div> */}
          {/* ARROWS */}
          <div className="custom-prev" ref={prevRef}>
            <img src="/assets/blue-icon1.svg" alt="Prev" />
          </div>
          <div className="custom-next" ref={nextRef}>
            <img src="/assets/blue-icon2.svg" alt="Next" />
          </div>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            loop={true}
            pagination={{
              clickable: true,
            }}
            spaceBetween={20}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1200: {
                slidesPerView: 3,
              },
              1400: {
                slidesPerView: 4,
              },
            }}
            className="package-home-swiper"
          >
            {packages.map((pkg) => (
              <SwiperSlide key={pkg.id}>
                <div className="slide-item">
                  <div className="package-card">
                    <div className="image-box">
                      <img src={pkg.image} alt={pkg.title} />

                      <span className="days">{pkg.days}</span>

                      <span className="location-pill">
                        <span className="dot">
                          <img
                            src="/assets/homepageicons/octicon_location-24.png"
                            alt=""
                            className="locationIcon"
                          />
                        </span>

                        {pkg.location}
                      </span>
                    </div>

                    <div className="card-body">
                      <h3>{pkg.title}</h3>

                      <div className="stars">
                        {Array.from({ length: pkg.rating || 0 }, (_, i) => (
                          <img key={i} src="/assets/card-star.svg" alt="star" />
                        ))}
                      </div>

                      <p className="desc">{pkg.shortDescription}</p>

                      <div className="bottom">
                        <div>
                          <p className="small">Starts From</p>

                          <h4>{pkg.price}</h4>

                          <p className="small">Net Agent Rate</p>
                        </div>

                        <button
                          onClick={() =>
                            navigate(
                              `/destination/${countrySlug}/${pkg.slug}-${pkg.id}`,
                            )
                          }
                        >
                          View Package
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <p className="no-packages">
          No packages available for {activeCountry} yet.
        </p>
      )}
    </section>
  );
};

export default PackagesSection;

